import Axios from 'axios'
import router from '@/router'
import * as utils from '@/utils'
// Axios doc https://github.com/mzabriskie/axios
import Vuei18n from '@/i18n'
import { Message, MessageBox } from 'element-ui'

// Axios.defaults.baseURL = 'https://daaa57e0.ngrok.io/manage/v1/'
// Axios.defaults.baseURL = 'http://hermes.internetofapp.com/manage/v1/'
// Axios.defaults.baseURL = 'http://127.0.0.1:3000/manage/v1/'
Axios.defaults.baseURL = '/manage/v1/'
Axios.defaults.timeout = 20000
Axios.interceptors.response.use(
  resp => {
    return Promise.resolve(resp.data.data)
  },
  error => {
    let data = error.response.data
    let status = error.response.status
    let toLoginCodes = [1001, 1002, 1003]
    let otherCodes = [1004, 1005, 1006, 1007, 1009, 1010, 1011, 1012, 1018]
    let loginCodes = [9000,9001]
    const confirm = Vuei18n.t('common.confirm')
    const title = Vuei18n.t('user.alert')
    // if (status >= 500) {
      
    //   MessageBox.alert(Vuei18n.t(`error.error_default`), title, {
    //     confirmButtonText: confirm,
    //     callback: action => {
    //       if (router.currentRoute.name === 'login') return
    //       utils.removeStorage('pvsuser')
    //       router.push({name: 'login'})
    //     }
    //   })
    //   return Promise.reject(data.code)
    // }
    if (toLoginCodes.indexOf(data.code) > -1 ||status >= 500 ) {
      MessageBox.alert(Vuei18n.locale=='cn' ? data.detailCH :  data.detail , title, {
        confirmButtonText: confirm,
        callback: action => {}
      })
      utils.removeStorage('pvsuser')
      router.push({ name: 'login' })
    } else{
      MessageBox.alert(Vuei18n.locale=='cn' ? data.detailCH :  data.detail , title, {
        confirmButtonText: confirm,
        callback: action => {}
      })
    } 
    return Promise.reject(data.code)
  }
)



// WEBPACK FOOTER //
// ./src/vuex/serviceConfig.js